export default "__VITE_ASSET__ByMECjKc__"